import React from "react";

import { PlainButton, classnames } from "@culturehq/components";

const OrganizationRow = ({
  children,
  className,
  currentOrganizationId,
  onSelectOrganization,
  organization: { id, name, logo },
  withDefault
}) => {
  const handleOrganizationClick = () => {
    if (onSelectOrganization) {
      onSelectOrganization(id);
    }
  };

  return (
    <PlainButton className={classnames("OrganizationRow", className, { Selected: withDefault && currentOrganizationId === id })} onClick={handleOrganizationClick}>
      <div className="OrganizationRow-Container">
        <img className="OrganizationRow-Image" src={logo.originalUrl} alt={name} />
        <h4 className="OrganizationRow-Name">{name}</h4>
      </div>
      {children}
    </PlainButton>
  );
};

export default OrganizationRow;
